export const sharedStoreConfig = {
  reducer: {},
  middleware: [],
};
